<template>
<div class="main-header-page">
	<v-breadcrumbs>
		<div>
			<app-tooltip-button
			color="blue"
			icon="settings"
			text="Configuración"
			@click-icon="openConfiguration"
			/>
		</div>
		<v-icon slot="divider">forward</v-icon>
		<v-breadcrumbs-item
			append
			v-for="(item, index) in breadcrumbs"
			:key="`${item.title}-${index}`"
			@click.native="openLink(item)"
		>
			<h3>{{ item.title }}</h3>
		</v-breadcrumbs-item>
	</v-breadcrumbs>
	<div class="header-page-actions"
		v-if="toShow">
		<v-btn
			v-if="exportToPdf"
			@click.prevent="downloadDispatch"
			class="header-page-download-document primary mr-2">
			<img :src="`${$imageUrl}/icon-export-pdf.svg`" alt="" class="align-img">
		</v-btn>
		<v-btn
			v-if="showExcel"
			class="header-page-download-document primary"
			v-on:click="downloadDocument">
			<img :src="`${$imageUrl}/fill-1.svg`" alt="download" height="17">
		</v-btn>
		<v-btn
			v-if="showClean"
			v-on:click="cleanFilter">Limpiar</v-btn>
	</div>
	<div class="header-page-actions translate"
		v-if="quotation || sale">
		<v-btn
			flat
			class="header-page-download-document"
			v-on:click="downloadDocument">
			<img :src="`${$imageUrl}/download.svg`" alt="download" height="17">
		</v-btn>
		<v-btn
			flat
			class="header-page-download-document"
			v-on:click="print">
			<img :src="`${$imageUrl}/print.svg`" alt="download" height="17">
		</v-btn>
	</div>
</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function data() {
	return {
		breadcrumbs: [],
	};
}

function cleanFilter() {
	this.$emit('clean-product-filter');
}

function columnsToExport() {
	const columnsSelected = this.columns.filter(column => column.visible && !column.flagVisible);
	/* eslint-disable arrow-parens */
	const newColumns = columnsSelected.map(col => {
		const newCol = Object.assign({}, col);
		delete newCol.id;
		delete newCol.visible;
		delete newCol.checked;
		return newCol;
	});
	return newColumns;
}
function dataToExport() {
	let tableDataToExport = [];
	const columnsSelected = this.columns.filter(column => column.visible && !column.flagVisible);
	const columnsValues = columnsSelected.map(colVal => {
		const newColVal = Object.assign({}, colVal);
		return newColVal.value;
	});
	if (this.rows.length > 0) {
		tableDataToExport = this.rows.map(dataExport => {
			const newData = Object.assign({}, dataExport);
			const keysData = Object.keys(dataExport);
			keysData.forEach(keyData => {
				if (columnsValues.every(keyCol => keyCol !== keyData)) {
					delete newData[keyData];
				}
			});
			return newData;
		});
	}
	return tableDataToExport;
}

function downloadDispatch() {
	this.$emit('download-dispatch');
}

function downloadDocument() {
	this.exportTable(this.columnsToExport, this.dataToExport, this.name);
}

function openLink({ name }) {
	this.goTo(name);
}

function print() {
	window.print();
}

function routeHandler(newVal) {
	this.breadcrumbs = newVal.matched.reduce((acum, route) => {
		const routesToAcum = [];
		const keys = route.regex.keys;
		if (keys.length > 0) {
			keys.forEach(key => {
				const name = this.$route.params[key.name];
				if (name) {
					const indexAcum = acum.findIndex(ac => ac.title === name);
					if (indexAcum === -1) {
						routesToAcum.push({ title: name });
					}
				}
			});
		}
		routesToAcum.push({ name: route.name, title: route.meta.title });
		return acum.concat(routesToAcum);
	}, []);
}

function openConfiguration() {
	this.goTo('page-configuration');
}

export default {
	name: 'header-page',
	computed: {
		columnsToExport,
		dataToExport,
	},
	data,
	components: {
		appTooltipButton,
	},
	methods: {
		cleanFilter,
		downloadDispatch,
		downloadDocument,
		openLink,
		openConfiguration,
		print,
	},
	props: {
		columns: {
			type: Array,
		},
		exportToPdf: {
			default: false,
			type: Boolean,
		},
		name: {
			type: String,
		},
		rows: {
			type: Array,
		},
		showClean: {
			default: true,
			type: Boolean,
		},
		showExcel: {
			default: true,
			type: Boolean,
		},
		title: {
			type: String,
			required: true,
		},
		toShow: {
			default: false,
			type: Boolean,
		},
		quotation: {
			default: false,
			type: Boolean,
		},
		sale: {
			default: false,
			type: Boolean,
		},
	},
	watch: {
		$route: {
			handler: routeHandler,
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.main-header-page {
	@include flex-between;
	background-color: white;
	border-bottom: 2px solid map-get($colors, base);
	flex-wrap: wrap;
	min-height: 52px;
	padding: 0 70px;
	width: 100vw;

	.header-page-title {
		color: map-get($colors, paginationText);
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, large);
		margin: 0px;
	}
	.header-page-actions {
		@include flex-between;
		margin-left: 40px;
		.btn {
			@include txt-config(open-semibold, small10);
			background-color: map-get($colors, orange-btn);
			border-radius: 5px;
			color: white;
			height: 25px;
			min-width: 58px;
			text-transform: capitalize;
		}
		.header-page-download-document {
			@include flex-center;
			min-width: 25px;
			margin: 0px;
		}
	}
}
.translate {
	transform: translateX(-200px);
	display: grid !important;
	grid-template-columns: 20px 20px;
	grid-column-gap: 20px;
}
</style>





// WEBPACK FOOTER //
// src/components/shared/header-page.vue